import {Text} from '../../components/1elements'
import BulkImportFormatTemplate from '../../components/5templates/BulkImportFormatTemplate'

const Dashboard = () => {
    const header = 'Add Multiple Dashboard Entries a Location from a CSV file'
    const description = (
        <>If you have new dashboard data points to be added for a location, you can add the information in the file to import all of them at once.
            Before importing the data, review the
            <a href={'/format/dashboard#formatGuidelines'}>format guidelines</a> below to avoid
            <a href={'/format/dashboard#commonErrors'}>common errors</a> and to ensure a smooth import operation.</>
    )

    const beforeYouBegin = (<>
        <li><Text type={'bulkImportRuleBody'}>
            <b>Validate this is the right way to proceed</b>- Use this option if you have multiple imports. You can
            import up to NEW 1000 contacts per client location. <b>Note</b> that you can do a single import by using
            the inbuilt smart form under data management.
        </Text></li>
        <li><Text type={'bulkImportRuleBody'}>
            <b>Make sure you have all the information ready</b>- Creating a dashboard data entry requires information
            related to various Key Performance Indicators like the client satisfaction score, inspection score, incident
            count etc. The data entered for a certain date becomes the primary link to associate the KPI information and
            display it on the dashboard for a location. Keep all the information ready and refer to the
            <a href={'/format/dashboard#columnReference'}>column reference</a> to know about all the mandatory fields.
        </Text></li></>)

    const requiredColumns = [
        {
            columnName: 'Date',
            description: 'The Date for which the data points are being recorded for a client location',
            limit:  'No past date allowed',
            example: 'YYYY-MM-DD'
        },
        {
            columnName: 'Client Satisfaction Score',
            description: 'A score received from a client',
            limit:  'Range 0-100',
            example: '100, 95, 73 etc. (no decimals allowed)'
        },
        {
            columnName: 'Inspection Score',
            description: 'Inspection quality score given by a supervisor',
            limit:  'Range 0-100',
            example: '100, 95, 73 etc. (no decimals allowed)'
        },
        {
            columnName: 'Compliance Score',
            description: 'Aggregate compliance score based on one or more compliance requirements, provided by the supervisor',
            limit:  'Range 0-100',
            example: '100, 95, 73 etc. (no decimals allowed)'
        },
        {
            columnName: 'Incident',
            description: 'Number of incidents on site involving any of the Bee- Clean staff/cleaner',
            limit:  'Whole numbers only',
            example: '1, 2, 3 etc.'
        },
        {
            columnName: 'Report',
            description: 'No. of complaints received from a client regarding the service provided at the location',
            limit:  'Whole numbers only',
            example: '1, 2, 3 etc.'
        },
        {
            columnName: 'Comment',
            description: 'Feedback provided/received on a date',
            limit:  'up to 500 Characters allowed',
            example: ''
        },
        {
            columnName: 'Name',
            description: 'Name of the reviewer providing the comment',
            limit:  'up to 50 characters allowed.',
            example: 'Ann L. Marie'
        },
        {
            columnName: 'Type',
            description: 'Only allowed values for the type are “Client” and “Staff”',
            limit:  'Enter either “Client” or “Staff” as text value',
            example: 'Client, Staff'
        },
    ]

    const optionalColumns = [
        {
            columnName: 'N/A',
            description: '',
            format: '',
            limit:  '',
            example: ''
        },
    ]

    const columnReferencePath = '/format/contacts#columnReference'

    return (
        <BulkImportFormatTemplate header={header} description={description} beforeYouBegin={beforeYouBegin}
                                  requiredColumns={requiredColumns} optionalColumns={optionalColumns} columnReferencePath={columnReferencePath}/>
    )
}

export default Dashboard